type labelParamProps = {
  label: string | undefined;
  children: React.ReactNode;
};

export const LabelParam = ({ label, children }: labelParamProps) => {
  return (
    <div className="flex justify-start pb-2">
      {label && (
        <div className="text-sm font-oxaniumMedium text-grey-medium w-1/3">
          {label}
        </div>
      )}
      {children}
    </div>
  );
};
